import IndicatorButton from 'components/indicator/IndicatorButton';
import IndicatorScreen from 'components/indicator/IndicatorScreen';
import { useInvitationIndex } from './hooks/useInvitationIndex';

import type { JSX } from 'react';

/**
 * 招待受付画面
 * ロジックは useInvitationIndex に委譲し、JSX のみを担当する。
 */
export default function InvitationIndex(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { initialized, processing, invitationState, onAccept } = useInvitationIndex();

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {/* 初期化中の表示 */}
      <IndicatorScreen visible={!initialized} />
      {/* 初期化後の表示 */}
      {initialized && (
        <>
          <main>
            <section className="section-404 vh-100">
              <div className="container">
                <div className="align-middle d-flex flex-column justify-content-center align-items-center">
                  <img
                    src="/img/common/logo.svg"
                    alt="BianQ ブランク"
                    className="d-block mx-auto card-logo"
                  />
                  {/* 招待が無効な場合 */}
                  {invitationState && invitationState.company == null && (
                    <h3>この招待はすでに失効しています。</h3>
                  )}
                  {/* 招待が有効な場合 */}
                  {invitationState && invitationState.company && (
                    <>
                      <h3>{invitationState.company.name}から招待を受けています。</h3>
                      <p className="text-center">参加するには招待を承認してください。</p>
                      <button
                        type="button"
                        onClick={onAccept}
                        className="btn btn-common d-inline-block moderate-blue"
                        disabled={processing}
                      >
                        <IndicatorButton visible={processing} />
                        招待を承認する
                      </button>
                    </>
                  )}
                </div>
              </div>
            </section>
          </main>
        </>
      )}
    </>
  );
}
